import { ViewModel } from '@bingads-webui/projection-grid-cross-page-select-all';

class NewViewModel extends ViewModel {
  constructor(options) {
    super(options);

    this.updateGridSelectionState = options.updateGridSelectionState;

    this.allSelected.subscribe(() => {
      options.gridView.trigger('didSelect', options.gridView.selectedKeys());
    });
  }

  rowsDidUpdate(...args) {
    super.rowsDidUpdate(...args);

    const selectionCount = this.selectedRowsCount;
    const totalCount = this.totalRowsTotalPageCount();
    const isMultiPage = this.pageSizeMoreThanOne();
    const isSinglePageAllSelected = this.currentPageAllRowsSelected();
    const isCrossPageAllSelected = this.allSelected();

    this.updateGridSelectionState({
      selectionCount,
      totalCount,
      isMultiPage,
      isSinglePageAllSelected,
      isCrossPageAllSelected,
    });
  }
}

export function getCrossPageSelectPlugin({
  updateGridSelectionState,
}) {
  let viewModel;

  return {
    onSelectCrossPage() {
      viewModel.selectAll();

      return false;
    },
    plugin: definePlugin => definePlugin('crossPageSelectAll', [
      'config',
      'gridView',
      'pagination',
    ], (config, gridView, pagination) => {
      const deselectAllOnReloadWhenNotAllSelected = !(config.plugins.crossPageSelectAll &&
        config.plugins.crossPageSelectAll.disableDeselectAll);

      viewModel = new NewViewModel({
        updateGridSelectionState,
        gridView,
        pagination,
        i18n: { getString: () => '' },
        deselectAllOnReloadWhenNotAllSelected,
      });

      return {
        viewModel,
        selectAll() {
          viewModel.selectAll();
        },
        deselectAll() {
          viewModel.deselectAll();
        },
        get isAllSelected() {
          return viewModel.allSelected();
        },
      };
    }),
  };
}
